var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellnotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08268 15.7797C14.3349 15.7797 16.7647 15.1059 16.9993 12.4015C16.9993 9.69888 15.3053 9.87267 15.3053 6.55672C15.3053 3.9666 12.8503 1.01961 9.08268 1.01961C5.31507 1.01961 2.86004 3.9666 2.86004 6.55672C2.86004 9.87267 1.16602 9.69888 1.16602 12.4015C1.40161 15.1161 3.83139 15.7797 9.08268 15.7797Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M11.3066 18.5827C10.0361 19.9935 8.05416 20.0102 6.77148 18.5827",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellnotify);
export default __webpack_public_path__ + "static/media/bellnotify.dfe8b938afb4000f83e8d93387dff122.svg";
export { ForwardRef as ReactComponent };